module.exports = __webpack_public_path__ + "static/media/designs1.4f41c7a8.png";